import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '../users/users.model';

export const UserProfileActions = createActionGroup({
  source: 'UserProfile',
  events: {
    'Load UserProfiles': emptyProps(),
    'Load UserProfiles Success': props<{ data: User }>(),
    'Load UserProfiles Failure': props<{ error: any }>(),
  }
});
